export const HORIZONTAL_SCROLL_CONTAINERS =
  '.MuiTableContainer-root, .table-scroll-wrapper';

// Styled WebKit scrollbars never auto-hide; the standard properties would override them in Chromium, so they apply only elsewhere.
export function visibleScrollbarStyles(thumb: string) {
  return {
    '&::-webkit-scrollbar': { height: 10, width: 10 },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumb,
      borderRadius: 5,
      border: '2px solid transparent',
      backgroundClip: 'content-box',
    },
    '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumb} transparent`,
    },
  };
}
